// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/cash/plasma/common/InstrumentSelectionOption.proto (package squareup.cash.plasma.common, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CashInstrumentType } from "../../../franklin/cash_instrument_type_pb";
import { file_squareup_franklin_cash_instrument_type } from "../../../franklin/cash_instrument_type_pb";
import type { ProcessingMode } from "../../moneta/core/models_pb";
import { file_squareup_cash_moneta_core_models } from "../../moneta/core/models_pb";
import { file_squareup_common_governance_v0_semantic_types } from "../../../common/governance/v0/semantic_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/cash/plasma/common/InstrumentSelectionOption.proto.
 */
export const file_squareup_cash_plasma_common_InstrumentSelectionOption: GenFile = /*@__PURE__*/
  fileDesc("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", [file_squareup_franklin_cash_instrument_type, file_squareup_cash_moneta_core_models, file_squareup_common_governance_v0_semantic_types]);

/**
 * @generated from message squareup.cash.plasma.common.InstrumentSelectionOption
 */
export type InstrumentSelectionOption = Message<"squareup.cash.plasma.common.InstrumentSelectionOption"> & {
  /**
   * @generated from oneof squareup.cash.plasma.common.InstrumentSelectionOption.selection_option
   */
  selectionOption: {
    /**
     * @generated from field: squareup.cash.plasma.common.NewLinkSelectionOption new_link = 1;
     */
    value: NewLinkSelectionOption;
    case: "newLink";
  } | {
    /**
     * @generated from field: squareup.cash.plasma.common.ReplaceLinkSelectionOption replace_link = 2;
     */
    value: ReplaceLinkSelectionOption;
    case: "replaceLink";
  } | {
    /**
     * @generated from field: squareup.cash.plasma.common.ExistingLinkSelectionOption existing_link = 3;
     */
    value: ExistingLinkSelectionOption;
    case: "existingLink";
  } | {
    /**
     * @generated from field: squareup.cash.plasma.common.DigitalWalletSelectionOption digital_wallet = 4;
     */
    value: DigitalWalletSelectionOption;
    case: "digitalWallet";
  } | {
    /**
     * @generated from field: squareup.cash.plasma.common.ExistingCustomSelectionOption existing_custom = 5;
     */
    value: ExistingCustomSelectionOption;
    case: "existingCustom";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message squareup.cash.plasma.common.InstrumentSelectionOption.
 * Use `create(InstrumentSelectionOptionSchema)` to create a new message.
 */
export const InstrumentSelectionOptionSchema: GenMessage<InstrumentSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 0);

/**
 * @generated from message squareup.cash.plasma.common.NewLinkSelectionOption
 */
export type NewLinkSelectionOption = Message<"squareup.cash.plasma.common.NewLinkSelectionOption"> & {
  /**
   * @generated from field: optional squareup.franklin.CashInstrumentType instrument_type = 1;
   */
  instrumentType: CashInstrumentType;
};

/**
 * Describes the message squareup.cash.plasma.common.NewLinkSelectionOption.
 * Use `create(NewLinkSelectionOptionSchema)` to create a new message.
 */
export const NewLinkSelectionOptionSchema: GenMessage<NewLinkSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 1);

/**
 * @generated from message squareup.cash.plasma.common.ReplaceLinkSelectionOption
 */
export type ReplaceLinkSelectionOption = Message<"squareup.cash.plasma.common.ReplaceLinkSelectionOption"> & {
  /**
   * @generated from field: optional squareup.franklin.CashInstrumentType instrument_type = 1;
   */
  instrumentType: CashInstrumentType;

  /**
   * @generated from field: optional string instrument_token = 2;
   */
  instrumentToken: string;
};

/**
 * Describes the message squareup.cash.plasma.common.ReplaceLinkSelectionOption.
 * Use `create(ReplaceLinkSelectionOptionSchema)` to create a new message.
 */
export const ReplaceLinkSelectionOptionSchema: GenMessage<ReplaceLinkSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 2);

/**
 * @generated from message squareup.cash.plasma.common.ExistingLinkSelectionOption
 */
export type ExistingLinkSelectionOption = Message<"squareup.cash.plasma.common.ExistingLinkSelectionOption"> & {
  /**
   * @generated from field: optional squareup.franklin.CashInstrumentType instrument_type = 1;
   */
  instrumentType: CashInstrumentType;

  /**
   * @generated from field: optional string instrument_token = 2;
   */
  instrumentToken: string;

  /**
   * The selected option may contain more than one instrument. For example, we sometimes
   * consolidate the debit card & bank account options if they belong to the same bank.
   *
   * @generated from field: repeated squareup.cash.plasma.common.ExistingLinkSelectionOption.InstrumentOption options = 4;
   */
  options: ExistingLinkSelectionOption_InstrumentOption[];

  /**
   * @generated from field: optional squareup.cash.moneta.core.ProcessingMode processing_mode = 3;
   */
  processingMode: ProcessingMode;

  /**
   * @generated from field: optional bool is_consolidated = 5;
   */
  isConsolidated: boolean;
};

/**
 * Describes the message squareup.cash.plasma.common.ExistingLinkSelectionOption.
 * Use `create(ExistingLinkSelectionOptionSchema)` to create a new message.
 */
export const ExistingLinkSelectionOptionSchema: GenMessage<ExistingLinkSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 3);

/**
 * @generated from message squareup.cash.plasma.common.ExistingLinkSelectionOption.InstrumentOption
 */
export type ExistingLinkSelectionOption_InstrumentOption = Message<"squareup.cash.plasma.common.ExistingLinkSelectionOption.InstrumentOption"> & {
  /**
   * @generated from field: optional squareup.franklin.CashInstrumentType instrument_type = 1;
   */
  instrumentType: CashInstrumentType;

  /**
   * @generated from field: optional string instrument_token = 2;
   */
  instrumentToken: string;
};

/**
 * Describes the message squareup.cash.plasma.common.ExistingLinkSelectionOption.InstrumentOption.
 * Use `create(ExistingLinkSelectionOption_InstrumentOptionSchema)` to create a new message.
 */
export const ExistingLinkSelectionOption_InstrumentOptionSchema: GenMessage<ExistingLinkSelectionOption_InstrumentOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 3, 0);

/**
 * @generated from message squareup.cash.plasma.common.ExistingCustomSelectionOption
 */
export type ExistingCustomSelectionOption = Message<"squareup.cash.plasma.common.ExistingCustomSelectionOption"> & {
  /**
   * Opaque to lynx and clients. This will be available as-is on the instrument selection blocker
   * result.
   *
   * @generated from field: optional bytes encoded_custom_submission = 1;
   */
  encodedCustomSubmission: Uint8Array;
};

/**
 * Describes the message squareup.cash.plasma.common.ExistingCustomSelectionOption.
 * Use `create(ExistingCustomSelectionOptionSchema)` to create a new message.
 */
export const ExistingCustomSelectionOptionSchema: GenMessage<ExistingCustomSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 4);

/**
 * @generated from message squareup.cash.plasma.common.DigitalWalletSelectionOption
 */
export type DigitalWalletSelectionOption = Message<"squareup.cash.plasma.common.DigitalWalletSelectionOption"> & {
  /**
   * @generated from field: optional squareup.cash.plasma.common.DigitalWalletSelectionOption.Type type = 1;
   */
  type: DigitalWalletSelectionOption_Type;

  /**
   * Used for cases where the client needs to pass additional data for the instrument submission.
   * Required for digital wallet flows (ex. Apple Pay)
   *
   * @generated from oneof squareup.cash.plasma.common.DigitalWalletSelectionOption.additional_params
   */
  additionalParams: {
    /**
     * @generated from field: squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload apple_pay_payload = 2;
     */
    value: DigitalWalletSelectionOption_ApplePayPayload;
    case: "applePayPayload";
  } | {
    /**
     * @generated from field: squareup.cash.plasma.common.DigitalWalletSelectionOption.GooglePayPayload google_pay_payload = 4;
     */
    value: DigitalWalletSelectionOption_GooglePayPayload;
    case: "googlePayPayload";
  } | { case: undefined; value?: undefined };

  /**
   * Used in requirement handling to send back the created Lynx instrument.
   * Required for digital wallet flows (ex. Apple Pay)
   *
   * @generated from field: optional squareup.cash.plasma.common.DigitalWalletSelectionOption.InstrumentLink instrument_link = 3;
   */
  instrumentLink?: DigitalWalletSelectionOption_InstrumentLink;
};

/**
 * Describes the message squareup.cash.plasma.common.DigitalWalletSelectionOption.
 * Use `create(DigitalWalletSelectionOptionSchema)` to create a new message.
 */
export const DigitalWalletSelectionOptionSchema: GenMessage<DigitalWalletSelectionOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5);

/**
 * @generated from message squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload
 */
export type DigitalWalletSelectionOption_ApplePayPayload = Message<"squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload"> & {
  /**
   * @generated from field: optional string data = 1;
   */
  data: string;

  /**
   * @generated from field: optional squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload.Header header = 2;
   */
  header?: DigitalWalletSelectionOption_ApplePayPayload_Header;

  /**
   * @generated from field: optional string signature = 3;
   */
  signature: string;

  /**
   * @generated from field: optional string version = 4;
   */
  version: string;
};

/**
 * Describes the message squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload.
 * Use `create(DigitalWalletSelectionOption_ApplePayPayloadSchema)` to create a new message.
 */
export const DigitalWalletSelectionOption_ApplePayPayloadSchema: GenMessage<DigitalWalletSelectionOption_ApplePayPayload> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5, 0);

/**
 * @generated from message squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload.Header
 */
export type DigitalWalletSelectionOption_ApplePayPayload_Header = Message<"squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload.Header"> & {
  /**
   * @generated from field: optional string application_data = 1;
   */
  applicationData: string;

  /**
   * @generated from field: optional string ephemeral_public_key = 2;
   */
  ephemeralPublicKey: string;

  /**
   * @generated from field: optional string wrapped_key = 3;
   */
  wrappedKey: string;

  /**
   * @generated from field: optional string public_key_hash = 4;
   */
  publicKeyHash: string;

  /**
   * @generated from field: optional string transaction_id = 5;
   */
  transactionId: string;
};

/**
 * Describes the message squareup.cash.plasma.common.DigitalWalletSelectionOption.ApplePayPayload.Header.
 * Use `create(DigitalWalletSelectionOption_ApplePayPayload_HeaderSchema)` to create a new message.
 */
export const DigitalWalletSelectionOption_ApplePayPayload_HeaderSchema: GenMessage<DigitalWalletSelectionOption_ApplePayPayload_Header> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5, 0, 0);

/**
 * @generated from message squareup.cash.plasma.common.DigitalWalletSelectionOption.GooglePayPayload
 */
export type DigitalWalletSelectionOption_GooglePayPayload = Message<"squareup.cash.plasma.common.DigitalWalletSelectionOption.GooglePayPayload"> & {
  /**
   * @generated from field: optional string token = 1;
   */
  token: string;

  /**
   * Used to dedupe repeated submission of the same Google Pay payload upon intermittent failure.
   *
   * @generated from field: optional string idempotence_token = 2;
   */
  idempotenceToken: string;
};

/**
 * Describes the message squareup.cash.plasma.common.DigitalWalletSelectionOption.GooglePayPayload.
 * Use `create(DigitalWalletSelectionOption_GooglePayPayloadSchema)` to create a new message.
 */
export const DigitalWalletSelectionOption_GooglePayPayloadSchema: GenMessage<DigitalWalletSelectionOption_GooglePayPayload> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5, 1);

/**
 * @generated from message squareup.cash.plasma.common.DigitalWalletSelectionOption.InstrumentLink
 */
export type DigitalWalletSelectionOption_InstrumentLink = Message<"squareup.cash.plasma.common.DigitalWalletSelectionOption.InstrumentLink"> & {
  /**
   * @generated from field: optional string finplat_instrument_token = 1;
   */
  finplatInstrumentToken: string;

  /**
   * @generated from field: optional squareup.franklin.CashInstrumentType instrument_type = 2;
   */
  instrumentType: CashInstrumentType;

  /**
   * @generated from field: optional string owner_token = 3;
   */
  ownerToken: string;
};

/**
 * Describes the message squareup.cash.plasma.common.DigitalWalletSelectionOption.InstrumentLink.
 * Use `create(DigitalWalletSelectionOption_InstrumentLinkSchema)` to create a new message.
 */
export const DigitalWalletSelectionOption_InstrumentLinkSchema: GenMessage<DigitalWalletSelectionOption_InstrumentLink> = /*@__PURE__*/
  messageDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5, 2);

/**
 * @generated from enum squareup.cash.plasma.common.DigitalWalletSelectionOption.Type
 */
export enum DigitalWalletSelectionOption_Type {
  /**
   * @generated from enum value: APPLE_PAY = 1;
   */
  APPLE_PAY = 1,

  /**
   * @generated from enum value: GOOGLE_PAY = 2;
   */
  GOOGLE_PAY = 2,
}

/**
 * Describes the enum squareup.cash.plasma.common.DigitalWalletSelectionOption.Type.
 */
export const DigitalWalletSelectionOption_TypeSchema: GenEnum<DigitalWalletSelectionOption_Type> = /*@__PURE__*/
  enumDesc(file_squareup_cash_plasma_common_InstrumentSelectionOption, 5, 0);

